import "./WizardDisclaimerStep.scss";
import {IComponentOptions} from "angular";

export const DisclaimerStep = "tfWizardDisclaimerStep";

export function disclaimerStep(parentDir: string): IComponentOptions {
    return {
        templateUrl: `${parentDir}/steps/disclaimer/WizardDisclaimerStep.html`,
        controllerAs: "ctrl",
        controller: WizardDisclaimerStepController
    };
}

export class WizardDisclaimerStepController {

}
